import type {
  SkipSegment as ApiSkipSegment,
  SeriesPlaylist,
} from '@setplex/tria-api'

import { useMemo } from 'react'

type UseShowSkipSegmentsParams = {
  rawSkipSegments: ApiSkipSegment[] | undefined
  seriesPlaylist: SeriesPlaylist | null
  isTrailer: boolean
  isVertical: boolean
}

export function useShowSkipSegments({
  rawSkipSegments,
  seriesPlaylist,
  isTrailer,
  isVertical,
}: UseShowSkipSegmentsParams) {
  const hasNextEpisode = Boolean(seriesPlaylist?.nextEpisode) && !isTrailer

  const playerSkipSegments = useMemo(() => {
    if (!rawSkipSegments?.length || isVertical || isTrailer) return undefined

    return rawSkipSegments.map((segment) =>
      segment.type === 'CREDITS' && hasNextEpisode
        ? { ...segment, type: 'NEXT_EPISODE' as const }
        : segment
    )
  }, [hasNextEpisode, isTrailer, isVertical, rawSkipSegments])

  return { playerSkipSegments }
}
